import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

import type { GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult } from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentBaseCreativesResult>({
    results: arrayOf(objectOf({ apiCampaignId: string, name: string })),
  });
